import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { CareGiver, CareGiverDetails, FetchResponse } from './types.ts'

const BASE_URL = '/api/dd_panel_caregiver/'

const getCareGiver = async () => {
  let fetchResponse: FetchResponse = {
    data: [],
    status: 200,
    error: null
  }

  try {
    const response = await httpClient.get<CareGiver[]>(BASE_URL)
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.status = error.response?.status as number
    } else {
      fetchResponse.error = 'Możliwy brak połączenia z serwerem'
      fetchResponse.status = 500
    }
  }

  return fetchResponse
}

const postCareGiver = async (data: CareGiverDetails) => {
  let fetchResponse: FetchResponse = {
    data: [],
    status: 201,
    error: null
  }

  try {
    const response = await httpClient.post<CareGiver[]>(BASE_URL, data)
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.status = error.response?.status as number
    } else {
      fetchResponse.error = 'Możliwy brak połączenia z serwerem'
      fetchResponse.status = 500
    }
  }

  return fetchResponse
}

const putCareGiver = async (id: number, data: CareGiverDetails) => {
  const url = BASE_URL + `${id}/`
  let fetchResponse: FetchResponse = {
    data: [],
    status: 201,
    error: null
  }

  try {
    const response = await httpClient.put<CareGiver[]>(url, data)
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.status = error.response?.status as number
    } else {
      fetchResponse.error = 'Możliwy brak połączenia z serwerem'
      fetchResponse.status = 500
    }
  }

  return fetchResponse
}

export const caregiverAPI = {
  getCareGiver,
  postCareGiver,
  putCareGiver
}
